/*
 * Ported verbatim from the legacy app's scripts/main.js (the inline app
 * logic, as opposed to scripts/app/components/*.js). Kept in its own module
 * so main.js can import it first, preserving the original concat order:
 * main.js, then each app/components/*.js file in turn.
 */
(function ($) {

    var $body = $('body');
    var filterArray = [];


    $body.on('click', '.nav-main-link', function (e) {
                var parent = $(this).parent();
                if (parent.hasClass('has-children')) {
                    e.preventDefault();
                    if (parent.hasClass('expanded')) {
                        $('.has-children').removeClass('expanded');
                    } else {
                        $('.has-children').removeClass('expanded');
                        parent.addClass('expanded')
                    }
                }
            }).on('click', '.hamburger', function (e) {
                    $body.toggleClass('menu-open');
            }).on('click', '.table-row-link', function (e) {
                e.preventDefault();

                var url = $(this).data('url');

                if (url) {
                    window.location.href = url;
                }

            });

    $(document).ready(function () {
        // DATA TABLE
        var athletes = window.athletes || [];
        var filterGroups = $('.filter-group');
        var filterWrapper = $('#js-list-filters');
        var language = {
            'decimal': '',
            'emptyTable': 'No data available in table',
            'info': 'Viser _START_ til _END_ af _TOTAL_ events',
            'infoEmpty': 'Viser 0 til 0 af 0 events',
            'infoFiltered': '(filtered from _MAX_ total entries)',
            'infoPostFix': '',
            'thousands': ',',
            'lengthMenu': 'Vis _MENU_ events per side',
            'loadingRecords': 'Loading...',
            'processing': 'Processing...',
            'search': 'Søg:',
            'searchPlaceholder': 'Søg stævne',
            'zeroRecords': 'Ingen events fundet',
            'paginate': {
                'first': 'Først',
                'last': 'Sidst',
                'next': 'Næste',
                'previous': 'Tilbage'
            },
            'aria': {
                'sortAscending': ': activate to sort column ascending',
                'sortDescending': ': activate to sort column descending'
            }
        };

        var events = $('#events').DataTable({
            'language': language,
            'order': [[1, "desc"]],
            'dom': "<'row'<'col-sm-12 col-md-6 d-none d-md-block'l><'col-sm-12 col-md-6'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-12 d-sm-block d-md-none'l><'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>"
        });

        var masterMeetingTable = $('#mastermeeting').DataTable({
            'language': language,
            'paging': false,
            'info': false,
            'searching': false,
            "ordering": false
        });

        var resetFilters = function () {
            filterArray = [];
            filterWrapper.html('');
            $('.list-filters').hide();
            filterGroups.val('');
            masterMeetingTable.search('', false, true, false).draw();
            history.pushState({}, null, window.location.href.split('?')[0]);
        };
        var renderFilters = function (filters) {
            var html = '';
            for (var i = 0, l = filters.length; i < l; i++) {
                if (filters[i]) {
                    html += '<div class="list-filter">' + filters[i] + '</div>';
                }
            }
            filterWrapper.html(html);
            $('.list-filters').show();
        };

        var sortMasterMeetingTable = function() {
            var url = window.location.href;
            if (url.split('?').length > 1) {
                var filterQuery = getParameterByName('filter', url);
                if (filterQuery) {
                    filterArray = filterQuery.split('|');
                    for (var i = 0, l = filterArray.length; i < l; i++) {
                        $(filterGroups[i]).val(filterArray[i]);
                    }

                    masterMeetingTable.search(filterArray.join(' '), false, true, false).draw();
                    renderFilters(filterArray);
                }
            } else {
                if (filterArray.length) {
                    resetFilters();
                }
            }
        };

        // EVENTS
        $body.on('change', '.filter-group', function (e) {
            e.preventDefault();

            filterArray[$(this).data('group-id')] = $(this).find(":selected").val();
            history.pushState({},null,'?filter=' + filterArray.join('|'));
            sortMasterMeetingTable();
        });

        $body.on('click', '.btn-reset-filters', function (e) {
            e.preventDefault();

            resetFilters();
        });

        $(window).on('popstate', function () {
            sortMasterMeetingTable();
        });

        // TYPEAHEAD athletesearch
        var substringMatcher = function (strs) {
            return function findMatches(q, cb) {
                var matches = [];
                var substrRegex = new RegExp(q, 'i');

                $.each(strs, function (i, str) {
                    if (substrRegex.test(str.Name)) {
                        matches.push(str);
                    }
                });

                cb(matches);
            };
        };


        $('#js-athlete-search-wrapper').find('.typeahead').typeahead({
                hint: true,
                highlight: true,
                minLength: 1
            },
            {
                name: 'athletes',
                display:'Name',
                source: substringMatcher(athletes)
            }).focus();
        $('.typeahead').on('typeahead:select', function (ev, suggestion) {
            if (suggestion && suggestion.EventsApiUrl) {
                window.location.href = suggestion.EventsApiUrl;
            }
        });

        $('.typeahead').on('typeahead:autocomplete', function (ev, suggestion) {
            if (suggestion && suggestion.EventsApiUrl) {
                window.location.href = suggestion.EventsApiUrl;
            }
        });


        //Init
        sortMasterMeetingTable();
        var athleteId = getParameterByName('athleteId');
        if (athleteId) {
            for (var i = 0, l = athletes.length; i < l; i++) {
                if (athletes[i].AthleteId == athleteId) {
                    $('#js-athlete-searched-for').show().find('.athlete-name').text(athletes[i].Name);
                    break;
                }
            }
        }

    });


    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }


})(window.jQuery);
